// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__Ripic","insightsList":"newBusinessInsightsMenu_insightsList__2V7Pf","active":"newBusinessInsightsMenu_active__2NFEz"};